import React from "react";
import T from "prop-types";

import { GridTable } from "2g-grid";

import useZadostiOdsouhlaseneTable from "./useZadostiOdsouhlaseneTable";

export function ZadostiOdsouhlaseneTable({
  datumOd,
  datumDo,
  zdroj,
  hideIfEmpty = false
}) {
  const grid = useZadostiOdsouhlaseneTable({ datumOd, datumDo, zdroj });

  return !grid.data?.length && hideIfEmpty ? null : (
    <>
      <div className="b2b-zadostiTable-content">
        <GridTable {...grid} />
      </div>
    </>
  );
}

ZadostiOdsouhlaseneTable.propTypes = {
  datumOd: T.instanceOf(Date),
  datumDo: T.instanceOf(Date),
  zdroj: T.object,
  hideIfEmpty: T.bool
};

export default React.memo(ZadostiOdsouhlaseneTable);
